import type { LDContext } from '../types/types';

/**
 * Get the kind of a context.
 * @param context - The context to get the kind of.
 * @returns The kind of the context.
 * If the context is a multi-kind context, the kind will be "multi".
 * If the context is a single-kind context, the kind will be the kind of the context.
 */
export function getContextKind(context: LDContext): string {
  if ('kind' in context) {
    return String(context.kind);
  }
  return '';
}
